
const urlMode = 'list'; // list 或 default
export { urlMode };
export default [
  'https://api.cdcoma.com',
  'https://api.cdcomb.com',
  'https://api.cdcoin.me',
  'https://cd.cdcomcfs.com',
]
